import React from 'react';
import Container from 'react-bootstrap/Container';
import { useAuth } from "../../contexts/AuthContext"
import { useHistory } from "react-router-dom"
import Navbar from 'react-bootstrap/Navbar';
import logo from './logo.png'
import { Button } from 'antd';


function NavBarComponent() {
  const { currentUser, logout } = useAuth() 
  const history = useHistory()
  async function handleLogout() {
      await logout()
      history.push("/login")
  }


  return (
    <>
    <Navbar bg="dark" variant="dark">
      <Container className=''>
        <Navbar.Brand className='' style={{ flexDirection: 'row' }}>

        <img src={logo} alt="Girl in a jacket" width="50" height="50">
        </img>

        <span className='ml-2'>
        Paws Up
        </span>
          
          </Navbar.Brand>
        <Navbar.Toggle />
        <Navbar.Collapse className="justify-content-end">
          {/* <Navbar.Text>
            {currentUser ? currentUser.email : 'Logged Out'} 
          </Navbar.Text> */}
          <Navbar.Text>
            <Button danger type='primary' onClick={handleLogout}>
              Logout
            </Button>
          </Navbar.Text>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
}

export default NavBarComponent;